import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  partnersOffersApi,
  partnersOffersApiKeys,
  type PartnerOfferBody,
  type PartnerOfferResponse,
} from '@/api/routes/partners/partners.offers.api';

/** Create (no id) or edit an offer. The form owns the error UX (field errors and the inline alert). */
export const usePartnersSaveOffer = (id?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: PartnerOfferBody) =>
      (id ? partnersOffersApi.update(id, data) : partnersOffersApi.create(data)).then(
        (res) => res.data,
      ),
    meta: { showUserMessage: false },
    onSuccess: ({ offer }: PartnerOfferResponse) => {
      queryClient.setQueryData(partnersOffersApiKeys.detail(offer.id), offer);
      return queryClient.invalidateQueries({ queryKey: partnersOffersApiKeys.all });
    },
  });
};
